import {apolloClient} from '@/setup/apollo-setup';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';
import {
  ADD_CLASSROOM,
  DELETE_CLASSROOM,
  GET_CLASSROOMS,
  GET_AVAILABLE_CLASSROOMS,
  GET_CLASSROOMS_BY_FILTER,
  GET_CLASSROOMS_BY_STUDENT_NOT_REGISTER,
  GET_LEARNING_CLASSROOMS,
  GET_CLASSROOM,
  UPDATE_CLASSROOM,
} from '@/queries/modules/class-room/classRoom';

export async function getClassRooms(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_CLASSROOMS,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setClassRooms', data.getClassRooms);
      context.commit('setSuccess', null);
      return data.getClassRooms
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getAvailableClassRooms(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_AVAILABLE_CLASSROOMS,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setClassRooms', data.getAvailableClassRooms);
      context.commit('setSuccess', null);
      return data.getAvailableClassRooms
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getClassRoomsByFilter(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_CLASSROOMS_BY_FILTER,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setClassRooms', data.getClassRoomsByFilter);
      context.commit('setSuccess', null);

      return data.getClassRoomsByFilter;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getClassRoomsByFilterOnlyCanLearn(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_CLASSROOMS_BY_FILTER,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setClassRooms', data.getClassRoomsByFilterOnlyCanLearn);
      context.commit('setSuccess', null);

      return data.getClassRoomsByFilterOnlyCanLearn;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getLearningClassRooms(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_LEARNING_CLASSROOMS,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setClassRooms', data.getLearningClassRooms);
      context.commit('setSuccess', null);

      return data.getLearningClassRooms;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getClassRoomsByStudentNotRegister(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_CLASSROOMS_BY_STUDENT_NOT_REGISTER,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setClassRooms', data.getClassRoomsByStudentNotRegister);
      context.commit('setSuccess', null);

      return data.getClassRoomsByStudentNotRegister;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getClassRoom(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_CLASSROOM,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return context.state.classRoom;
    } else {
      context.commit('setClassRoom', data.getClassRoom);
      context.commit('setSuccess', null);
      return data.getClassRoom
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function addClassRoom(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_CLASSROOM,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const classRooms = [...context.state.classRooms];
      classRooms.push(data.addClassRoom);
      context.commit('setClassRooms', classRooms);
      context.commit('setSuccess', newItemSuccess(data.addClassRoom.nameLocal));

      return data.addClassRoom
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateClassRoom(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_CLASSROOM,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.classRooms.findIndex(item => item.id === data.updateClassRoom.nameLocal);
      const classRooms = [
        ...context.state.classRooms.slice(0, index),
        data.updateClassRoom,
        ...context.state.classRooms.slice(index + 1)
      ];
      context.commit('setClassRooms', classRooms);
      context.commit('setSuccess', updateItemSuccess(data.updateClassRoom.sectionNo));

      return data.updateClassRoom
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function deleteClassRoom(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_CLASSROOM,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const index = context.state.classRooms.findIndex(item => item.id === data.deleteClassRoom.nameLocal);
      const classRooms = [
        ...context.state.classRooms.slice(0, index),
        ...context.state.classRooms.slice(index + 1)
      ];
      context.commit('setClassRooms', classRooms);
      context.commit('setSuccess', deleteItemSuccess(data.deleteClassRoom.sectionNo));

      return data.deleteClassRoom
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

